import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import payoutActions from '../../actions/PayoutActions';
import PayoutFormBase from './PayoutFormBase';
import {Message} from '../index';

const mapStateToProps = state => {
    return {
        messages: state.get('localization').get('messageProperties'),
        payoutState: state.get('payout').toJS(),
        config: state.get('config').toJS()
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setForm: payload => dispatch(payoutActions.setForm(payload)),
        get: () => dispatch(payoutActions.get()),
        save: (model, history) => dispatch(payoutActions.save({ model, history })),
        hideModel: () => dispatch(payoutActions.hideError()),
        clearAlert: () => dispatch(payoutActions.clearAlert())
    };
};

@connect(
    mapStateToProps,
    mapDispatchToProps
)
class PayoutForm extends PayoutFormBase {
    SubmitBtn = () => {
        const { isDocSignClicked } = this.state;
        const { form } = this.props.payoutState;
        const payoutDisable = form.accountStatus && form.accountStatus === 'ACTIVE';
        const taxinfoDisable = form.status && form.status === 'ACTIVE';
        const disable = payoutDisable && taxinfoDisable && !isDocSignClicked;
        return (<button className="btn btn-primary btn-payout-submit" type="submit" disabled={disable}>
            <Message code="epic.esport.button.submit.account" />
        </button>);
    };

    handleSubmit = (model) => {
        const { payoutState, hideTax } = this.props;
        const { form } = payoutState;
        const { isDocSignClicked } = this.state;
        const payoutDisable = form.accountStatus && form.accountStatus === 'ACTIVE';
        const taxinfoDisable = form.status && form.status === 'ACTIVE';
        if (payoutDisable && (hideTax || (taxinfoDisable && isDocSignClicked))) {
            this.props.history.push('/competitive/success');
            return;
        }

        const { phoneNumber, ...formModel } = model;
        const phoneNo = phoneNumber ? { phoneNumber } : {}; // don't submit phone number if value is falsy

        const payload = {
            ...formModel,
            ...phoneNo,
            hideTax,
            accountStatus: form.accountStatus || null,
            status: form.status || null,
            foreignBank: formModel.foreignBank === 'true',
            foreignTax: formModel.foreignTax === 'true'
        };
        // if foreignTax is true and individual selected taxType will be ''
        if (!hideTax && !payload.taxType) {
            delete payload.taxType;
        }
        this.props.save(payload, this.props.history);
    };
}

export default withRouter(PayoutForm);
